import Text from "common/Typography/Text";
import React, { CSSProperties } from "react";
import styled from "styled-components";
import { typography } from "@shared/common/Themes/typography";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_VIRTUAL_LIST } from "common/constants";

interface PublicBotStatisticProps {
  statisticKey: string;
  statisticValue: string;
  showBorder?: boolean;
  style?: CSSProperties;
  isNegative?: boolean;
}

const PublicBotStatistic = ({
  statisticKey,
  statisticValue,
  showBorder = true,
  style,
  isNegative,
}: PublicBotStatisticProps) => {
  const isMobile = useMedia(
    [`(max-width: ${MOBILE_VIRTUAL_LIST})`],
    [true],
    false
  );

  return (
    <Wrapper $showBorder={showBorder} style={style}>
      <Text
        type={isNegative ? "danger" : "success"}
        $size={isMobile ? typography.fontSizes.M : typography.fontSizes.XL}
        $weight={typography.fontWeights.SEMI_BOLD}
      >
        {statisticValue}
      </Text>
      <Text
        type="secondary"
        $size={typography.fontSizes.S}
        style={{ whiteSpace: "wrap", textAlign: "center" }}
      >
        {statisticKey}
      </Text>
    </Wrapper>
  );
};

export default PublicBotStatistic;

const Wrapper = styled.div<{ $showBorder: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  ${(p) =>
    p.$showBorder &&
    `
  &:not(:last-of-type) {
    border-right: ${p.theme.borders.light};
    padding: 0 8px;
  }
  `};
`;
